/**
 * Lưu "chức năng yêu thích" mobile theo user — localStorage.
 * Mỗi mục là `${group}:${key}` trùng với submenuConfig (vd: hrm:tasks).
 */

const STORAGE_KEY = "ima_mobile_favorites_v1";

/** Mặc định lần đầu (tương đương bản hard code cũ) */
export const DEFAULT_MOBILE_FAVORITE_IDS = [
  "hrm:hrm_attendance",
  "hrm:tasks",
  "hrm:overtime",
];

export const MAX_MOBILE_FAVORITES = 24;

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.warn("mobileFavoritesStorage: không ghi được", e);
  }
}

/**
 * @param {string} [userId]
 * @returns {string[]}
 */
export function loadMobileFavoriteIds(userId) {
  const key = userId || "anonymous";
  const all = readAll();
  if (!(key in all)) {
    return [...DEFAULT_MOBILE_FAVORITE_IDS];
  }
  const list = all[key];
  if (!Array.isArray(list)) {
    return [...DEFAULT_MOBILE_FAVORITE_IDS];
  }
  return list.filter((id) => typeof id === "string" && id.includes(":"));
}

/**
 * @param {string} [userId]
 * @param {string[]} ids
 */
export function saveMobileFavoriteIds(userId, ids) {
  const key = userId || "anonymous";
  const all = readAll();
  const next = Array.from(
    new Set(ids.filter((id) => typeof id === "string" && id.includes(":")))
  ).slice(0, MAX_MOBILE_FAVORITES);
  all[key] = next;
  writeAll(all);
}

export function makeFavoriteId(group, key) {
  return `${group}:${key}`;
}

export function parseFavoriteId(id) {
  const i = id.indexOf(":");
  if (i <= 0) return null;
  return { group: id.slice(0, i), key: id.slice(i + 1) };
}
